import { isMenu } from "@bloomreach/spa-sdk";
import { computed } from "vue";
export async function useBrxmMenu(props) {
  const menu = computed(() => {
    const menuRef = props.component.getModels()?.menu;
    const menu2 = menuRef && props.page.getContent(menuRef);
    const isMenuDataHasItemsKey = menu2 && typeof menu2 === "object" && "items" in menu2 && Array.isArray(menu2.items);
    return isMenu(menu2) || isMenuDataHasItemsKey ? menu2 : void 0;
  });
  const items = menu.value?.getItems();
  return items;
}
